import { useQuery as l, useQueryClient as b, useMutation as m } from "@tanstack/react-query";
import s from "./objectives.api.js";
import { teachurKeys as y } from "../../constants/teachurKeys.js";
import { rollbackMarkObjectiveCompleted as F, toggleObjectiveOptimistically as j } from "./objectives.updater.js";
const Q = (e, t, r) => {
  const u = b();
  return m({
    mutationFn: async ({ objectiveId: a }) => s.markCompleted(a),
    onMutate: async ({ objectiveId: a, isCompleted: n }) => j(
      u,
      a,
      n,
      e,
      t
    ),
    onError: (a, n, i) => {
      var c;
      F(u, i, e, t), (c = r == null ? void 0 : r.onError) == null || c.call(r, a, n, i);
    },
    onSuccess: (a, n, ...i) => {
      var c;
      u.invalidateQueries({
        queryKey: y.objectives.detail(n.objectiveId)
      }), (c = r == null ? void 0 : r.onSuccess) == null || c.call(r, a, n, ...i);
    },
    ...r
  });
}, S = (e) => l({
  queryKey: y.objectives.detail(e),
  queryFn: async () => (await s.getOne(e)).data,
  enabled: !!e
}), K = (e) => m({
  mutationFn: async (t) => s.submitMediaFeedback(t),
  ...e
}), f = (e, t) => l({
  queryKey: y.mediaRatings.userRating(t),
  queryFn: async () => (await s.getUserMediaRating(e, t)).data.rating,
  enabled: !!e && !!t && !isNaN(e) && !isNaN(t)
}), N = (e) => {
  const t = b();
  return m({
    mutationFn: async ({
      objectiveId: r,
      mediaId: u,
      rating: a,
      mediaUrl: n,
      fileUrl: i,
      objectiveName: c,
      mediaDescription: g,
      userId: M,
      userName: d,
      userEmail: q,
      courseName: R
    }) => s.submitMediaRating(
      r,
      u,
      a,
      n,
      i,
      c,
      g,
      M,
      d,
      q,
      R
    ),
    onSuccess: (r, u) => {
      var a;
      t.invalidateQueries({
        queryKey: y.mediaRatings.userRating(u.mediaId)
      }), (a = e == null ? void 0 : e.onSuccess) == null || a.call(e, r, u);
    },
    ...e
  });
};
export {
  S as useGetObjectiveQuery,
  f as useGetUserMediaRatingQuery,
  Q as useMarkObjectiveCompletedMutation,
  K as useSubmitMediaFeedbackMutation,
  N as useSubmitMediaRatingMutation
};
